import { LocalisationHelper } from '@/helpers/LocalisationHelper';

export default async (context) => {
  const local = context.app.i18n.locale;
  const localisationHelper = new LocalisationHelper(
    context.$http,
    context.store,
    context.$auth,
    local ? local : 'fr'
  );

  const { route, $auth } = context;


  const queryCountry = route?.query?.country;
  const queryCurrency = route?.query?.currency;
  if (queryCountry && queryCurrency) {
    // $auth.$storage.setUniversal(
    //   'APP_COUNTRY_ISOCODE',
    //   queryCountry.toUpperCase()
    // );
    // $auth.$storage.setUniversal(
    //   'APP_CURRENCY_ISOCODE',
    //   queryCurrency.toUpperCase()
    // );

    localisationHelper.setAppCountryIsoCode(queryCountry);

    localisationHelper.setAppCurrency({
      currencyIsoCode: queryCurrency,
      currencySign: queryCurrency,
    });
  }

  // await localisationHelper.setListLanguages();
  // await localisationHelper.setListCountries();
  localisationHelper.init();
  try {
    await localisationHelper.setListCountries();
  } catch (error) {
    console.error('Error loading countries:', error);
  }
};
